module.exports = __webpack_public_path__ + "static/1d-68ccc77ab3a6912df5104af330813ef7.jpg";